// extracted by mini-css-extract-plugin
export var dropdownButton = "_1f-0";
export var fullWidthDropdownButton = "_1f-1";
export var icon = "_1f-3";
export var iconPlaceholder = "_1f-2";
export var menuItemRow = "_1f-5";
export var shortcutContainer = "_1f-4";